// JavaScript code for acf_blocks/programme-how-it-works-format-tabs component
(($) => {

    "use strict";
    if (!$('.acf-blocks-programme-how-it-works-format-tabs').length) {
        return
    }
    console.log("acf_blocks/programme-how-it-works-format-tabs scripts loaded...");

    $('.acf-blocks-programme-how-it-works-format-tabs').on('click', '.tab-title', function () {
        const $tab = $(this).parent('.tab');
        if ($tab.hasClass('active')) {
            return;
        }

        $tab.toggleClass('active').siblings('.tab').removeClass('active');
        $("html,body").scrollTop($tab.offset().top - 175);
    });

})(jQuery);